<template>
  <b-navbar toggleable="lg" type="light" variant="white">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <!-- <b-navbar-brand href="#">Marvel</b-navbar-brand> -->
    <b-navbar-brand href="#">
      <img
        src="../assets/Mlogo.png"
        alt="Marvel40M+ Logo"
        height="67"
      /> <h5 class="gradient-text"></h5> </b-navbar-brand>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto"> <!-- Align items to the right -->
        <!-- GitHub Link -->
        <b-nav-item href="#" target="_blank">
          <span class="nav_items"> <i class="fab fa-github"></i> Marvel-FX3D </span>
        </b-nav-item>

        <!-- Dataset Link -->
        <b-nav-item href="#" target="_blank">
          <span class="nav_items"> 🤗 Marvel Dataset </span>
        </b-nav-item>

        <!-- Project Page Link -->
        <b-nav-item href="#" target="_blank">
          <!-- emoji for webpage -->
          <span class="nav_items"> 🌐 Project Page </span>
        </b-nav-item>

        <!-- arXiv Link -->
        <b-nav-item href="https://arxiv.org/abs/2411.17945" target="_blank">
          <span class="nav_items"> 📜 Paper </span>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'HelloWorld',
};
</script>

<style>
/* Add spacing and consistent alignment */
b-navbar-nav {
  display: flex;
  gap: 15px; /* Space between items */
  font-size: 16px;
  font-weight: 500;
}

/* Add emoji styling if needed */
b-nav-item {
  display: flex;
  align-items: center;
  gap: 5px; /* Space between emoji and text */
  text-decoration: none;
  color: inherit;
}

b-navbar {
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
}

.nav_items {
  color: black;
  font-size: 18px;
  padding-right: 10px;
  text-decoration: none;
  transition: color 0.3s ease, text-decoration 0.3s ease; /* Smooth hover transition */
}

.nav_items:hover {
  color: #007bff; /* Change text color on hover */
}

</style>
